var pkg = require('../../package.json');

module.exports.SOUNDS_BASE_URL = 'https://media.twiliocdn.com/sdk/js/client/sounds/releases/1.0.0';
module.exports.RELEASE_VERSION = pkg.version;